import { Button } from '@/view/components/ui/button'
import { Input } from '@/view/components/ui/input'
import { ChevronLeft, ChevronRight, Search } from 'lucide-react'
import { Spinner } from '@/view/components/ui/spinner'
import { useLeadsController } from './useLeadsController'
import { LeadList } from './components/LeadList'
import { LeadSortDropdown } from './components/LeadSortDropdown'
import Links from './components/Links'

export const Leads = () => {
  const {
    data,
    isFetching,
    searchValue,
    handleSearchInputChange,
    openWhatsApp,
    contactedLeads,
    sort,
    handleSortChange,
    sortIcon,
    renderNoLeads,
    page,
    totalPages,
    handlePrevious,
    handleNext,
  } = useLeadsController()

  return (
    <div className="flex items-start gap-5">
      <div className="w-full rounded-2xl border border-gray01 p-8">
        <h2 className="mb-8 text-2xl font-semibold">Leads</h2>
        <div className="relative mt-4 flex w-full items-center">
          <Search size={20} className="z-2 absolute left-4 top-3" />
          <Input
            className="w-full rounded-lg pl-12"
            placeholder="Pesquisar"
            onChange={handleSearchInputChange}
            value={searchValue}
          />
          <LeadSortDropdown
            sort={sort}
            sortIcon={sortIcon}
            onSortChange={handleSortChange}
          />
        </div>
        <div className="mt-4 flex flex-col gap-4">
          {!isFetching && renderNoLeads()
            ? renderNoLeads()
            : data?.leads.map((lead, index) => (
                <LeadList
                  key={lead._id}
                  lead={lead}
                  contacted={contactedLeads.has(lead._id)}
                  onContactClick={() =>
                    openWhatsApp({
                      _id: lead._id,
                      phone: lead.phone,
                    })
                  }
                  isLast={index === data.leads.length - 1}
                />
              ))}
        </div>

        <div>
          {isFetching && (
            <div className="mt-4 flex items-center justify-center">
              <Spinner />
            </div>
          )}
        </div>
        <div className="mt-4 flex items-center justify-end gap-2">
          <Button
            variant="ghost"
            onClick={handlePrevious}
            disabled={page === 1}
          >
            <ChevronLeft />
          </Button>
          <div className="mx-4 flex gap-2">
            {page} de {totalPages}
          </div>
          <Button
            variant="ghost"
            onClick={handleNext}
            disabled={page === totalPages}
          >
            <ChevronRight />
          </Button>
        </div>
      </div>
      <Links />
    </div>
  )
}
